import getNodeName from "./getNodeName.js";
export default function isTableElement(element) {
  return ['table', 'td', 'th'].indexOf(getNodeName(element)) >= 0;
}


//////////////////
// WEBPACK FOOTER
// ./~/.store/@popperjs+core@2.9.2/~/@popperjs/core/lib/dom-utils/isTableElement.js
// module id = 564
// module chunks = 75